<template>
	<div class="chat-fans-info-box">
		<div class="chat-fans-i-wrap">
			<div class="chat-fans-i-basic">
				<div class="chat-fans-ib-avater">
					<img :src="fans.wx_photo" alt="">
				</div>
				<div class="chat-fans-ib-info">
					<div class="chat-fans-ib-name">{{fans.wx_name}}</div>
					<div class="chat-fans-ib-sign">{{(fans.sign == null || fans.sign == '') ? '未获取到签名，请更新好友信息重试' : fans.sign}}</div>
					<div class="chat-fans-ib-tools" v-if="fans.pageType === 'fans'">
						<span class="chat-fans-ib-msg"></span>
						<span class="chat-fans-ib-moment"></span>
					</div>
					<div class="chat-fans-ib-tools" v-else>
						<p>{{fans.sex == 2 ? '女' : '男'}}</p>
					</div>
				</div>
			</div>
			<div  v-if="fans.pageType === 'fans'">
				<div class="chat-fans-i-extra">
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">消息数量：</span>
						<span class="chat-fans-ie-text">{{msgCount}}条</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">是否僵尸粉：</span>
						<span class="chat-fans-ie-text">正常好友</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">微信标签：</span>
						<span class="chat-fans-ie-text">{{fans.fans_type}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">上次点赞时间：</span>
						<span class="chat-fans-ie-text">{{zanLastTime}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">地区：</span>
						<span class="chat-fans-ie-text">{{fans.country}}-{{fans.province}}-{{fans.city}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">点赞次数：</span>
						<span class="chat-fans-ie-text">{{zanCount}}条</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">微信号：</span>
						<span class="chat-fans-ie-text">{{fans.open_id}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">上次评论时间：</span>
						<span class="chat-fans-ie-text">{{commentLastTime}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">好友来源：</span>
						<span class="chat-fans-ie-text">对方通过扫一扫添加</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">评论次数：</span>
						<span class="chat-fans-ie-text">{{commentCount}}次</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">备注：</span>
						<span class="chat-fans-ie-text">{{fans.con_remark}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">上次聊天时间：</span>
						<span class="chat-fans-ie-text">{{lastChatTime}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">所属微信号：</span>
						<span class="chat-fans-ie-text">{{fans.custom_name}}（{{fans.identity}}）</span>
						<!-- <span class="chat-fans-ie-online"></span> -->
					</p>
				</div>
				<div class="chat-fans-i-tools">
					<div class="chat-fans-it-item" @click="goChat">
						<span class="chat-fans-it-icon chat-fans-it-send"></span>
						<span class="chat-fans-it-text">发消息</span>
					</div>
					<div class="chat-fans-it-item chat-fans-refresh">
						<span class="chat-fans-it-icon chat-fans-it-refresh"></span>
						<span class="chat-fans-it-text">更新好友消息</span>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="chat-fans-i-extra">
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">地区：</span>
						<span class="chat-fans-ie-text">{{fans.country}}-{{fans.province}}-{{fans.city}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">微信号：</span>
						<span class="chat-fans-ie-text">{{fans.from_vxid}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">好友来源：</span>
						<span class="chat-fans-ie-text">{{BasicConfig.fansScene[fans.scene]}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">添加时间：</span>
						<span class="chat-fans-ie-text">{{fans.create_time}}</span>
					</p>
					<p class="chat-fans-ie-item">
						<span class="chat-fans-ie-title">所属微信号：</span>
						<span class="chat-fans-ie-text">{{fans.custom_name}}（{{fans.identity}}）</span>
						<!-- <span class="chat-fans-ie-online"></span> -->
					</p>
				</div>
				<div class="chat-fans-i-tools">
					<div class="chat-fans-it-item" v-if="showPassBut && fans.pass_status !== undefined &&  fans.pass_status == 0">
						<span class="chat-fans-it-text" @click="passFans">通过好友验证</span>
					</div>
					<div class="chat-fans-it-item" style="background-color: #f35858;">
						<span class="chat-fans-it-text" @click="delFanspass">删除好友验证</span>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import BasicConfig from '../../../../config/BasicConfig.js'
	import {getRecentlyByFIdAndType} from '../../../network/local/recently.js'
	import {formatTimeToYMDHms} from '../../../functions/Common.js'
	import {webGetMomentZCData} from '../../../network/web/moments.js'
	import {getChatRecordCountByFansId} from '../../../network/local/chat-record.js'
	import {webDeleteFanspass} from '../../../network/web/fanspass.js'
	import {pushPassFans} from '../../../socket/socketEventSender.js'
	
	export default{
		name:'ChatFansInfo',
		props:{
			fansInfo:{
				type: Object,
				default:function(){
					return {}
				}
			},
			customList:{
				type: Array,
				default: []
			}
		},
		data(){
			return{
				BasicConfig:{},
				fans:{},
				msgCount: 0,
				lastChatTime: '',
				zanCount: 0,
				zanLastTime: '',
				commentCount: 0,
				commentLastTime: '',
				showPassBut: true
			}
		},		
		methods:{
			// 处理粉丝数据
			handleFansInfo(data){
				data = JSON.parse(JSON.stringify(data))
				if(data.wx_photo !== undefined){
					data.wx_photo = data.wx_photo.replace('/96','/0')
				}
				if(data.pageType === 'fans'){
					this.handleFans(data)
				}else if(data.pageType === 'news'){
					this.handleFanspass(data)
				}
				this.showPassBut = true
			},
			
			// 处理粉丝数据
			handleFans(data){
				// 拼接客服信息
				let custom_wxid = ''
				let custom_name = ''
				let phone_id = ''
				let identity = ''
				for (let i = 0; i < this.customList.length; i++) {
					if(this.customList[i].id === data.custom_id){
						custom_wxid = this.customList[i].open_id
						custom_name = this.customList[i].wx_name
						phone_id = this.customList[i].phone_id
						identity = this.customList[i].identity
						break
					}
				}
				data.custom_wxid = custom_wxid
				data.custom_name = custom_name
				data.phone_id = phone_id
				data.identity = identity
				this.fans = data
				// 查询最后一次聊天时间
				getRecentlyByFIdAndType(data.id,1,recently=>{
					if(recently){
						this.lastChatTime = formatTimeToYMDHms(recently.last_modified_time)
					}
				})
				// 获取当前好友的聊天消息总数
				getChatRecordCountByFansId(data.id,msgCount=>{
					this.msgCount = msgCount
				})
				// 获取点赞和评论的数据
				webGetMomentZCData(data.open_id,czData=>{
					if(czData){
						this.zanCount = czData.zanCount
						this.zanLastTime = czData.zanLastTime
						this.commentCount = czData.commentCount
						this.commentLastTime = czData.commentLastTime
					}
				})
				
			},
			
			// 处理新粉数据
			handleFanspass(data){
				// 拼接客服信息
				let custom_wxid = ''
				let custom_name = ''
				let phone_id = ''
				let identity = ''
				for (let i = 0; i < this.customList.length; i++) {
					if(this.customList[i].open_id === data.wxid){
						custom_wxid = this.customList[i].open_id
						custom_name = this.customList[i].wx_name
						phone_id = this.customList[i].phone_id
						identity = this.customList[i].identity
						break
					}
				}
				data.custom_wxid = custom_wxid
				data.custom_name = custom_name
				data.phone_id = phone_id
				data.identity = identity
				this.fans = data
			},
			
			// 删除进粉数据
			delFanspass(){
				let index = CHAT_LAYER.open({
					type: 3
				})
				if(this.fans.pageType === 'news' && this.fans.id > 0){
					webDeleteFanspass(this.fans.id,res=>{
						if(res){
							this.$emit('delete-fanspass-call',this.fans.id)
							CHAT_LAYER.close(index)
						}
					})
				}
			},
			
			// 推送socket添加指令
			passFans(){
				CHAT_LAYER.msg('指令推送成功，具体结果请稍后刷新查看',{icon: 1})
				this.showPassBut = false
				if(this.fans.pageType === 'news' && this.fans.id > 0){
					pushPassFans(this.fans.from_vxid,this.fans.scene,this.fans.ticket,this.fans.phone_id)
				}
			},
			
			// 跳转聊天页面
			goChat(){
				let query = {
					c_id: this.fans.custom_id,
					c_wxid: this.fans.custom_wxid,
					f_wxid: this.fans.open_id,
					type: 'fans'
				}
				this.$router.push({
					path: '/chat/chat',
					query:query
				})
			}
		},
		
		watch:{
			// 监听粉丝变化
			fansInfo(nVal){
				this.handleFansInfo(nVal)
			}
		},
		
		created() {
			this.BasicConfig = BasicConfig
			this.handleFansInfo(this.fansInfo)
		},
	}
</script>

<style>
	.chat-fans-info-box{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
		user-select: none;
	}
	.chat-fans-info-box .chat-fans-i-wrap{
		width: 90%;
		height: 90%;
		margin: 0 auto;
		margin-top: 5%;
		overflow-x: hidden;
		overflow-y: auto;
		padding: 40px;
	}
	.chat-fans-i-wrap .chat-fans-i-basic{
		width: 100%;
		height: 160px;
		padding: 20px;
		box-sizing: border-box;
		background-color: #f3f3f3;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: nowrap;
		border-radius: 4px;
		box-shadow: 0 1px 5px 0 #cacaca;
	}
	.chat-fans-i-basic .chat-fans-ib-avater{
		width: 120px;
		height: 120px;
		margin-right: 80px;
		background-color: #f3f3f3;
		position: relative;
	}
	.chat-fans-ib-avater img{
		width: 160px;
		height: 160px;
		position: absolute;
		display: block;
		top: -60px;
		left: 0;
		z-index: 10;
		border: 20px solid #f3f3f3;
		border-radius: 4px;
		background-color: #f3f3f3;
	}
	.chat-fans-i-basic .chat-fans-ib-info{
		flex-grow: 1;
		width: 0;
		height: 90px;
	}
	.chat-fans-ib-info .chat-fans-ib-name{
		height: 30px;
		line-height: 30px;
		font-weight: bold;
		font-size: 18px;
	}
	.chat-fans-ib-info .chat-fans-ib-sign{
		height: 30px;
		line-height: 30px;
		color: #888888;
	}
	.chat-fans-ib-info .chat-fans-ib-tools{
		height: 30px;
		overflow: hidden;
	}
	.chat-fans-ib-tools span{
		display: inline-block;
		width: 22px;
		height: 30px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 22px 22px;
		margin-right: 10px;
		vertical-align: middle;
		cursor: pointer;
	}
	.chat-fans-ib-tools p{
		line-height: 30px;
		color: #888888;
	}
	.chat-fans-ib-tools .chat-fans-ib-msg{
		background-image: url(../../../assets/img/comp-chat-active.png);
	}
	.chat-fans-ib-tools .chat-fans-ib-moment{
		background-image: url(../../../assets/img/nav-circle-active.png);
		background-size: 20px 20px !important;
	}
	.chat-fans-i-wrap .chat-fans-i-extra{
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
		background-color: #f3f3f3;
		border-radius: 4px;
		margin-top: 15px;
		box-shadow: 0 0 5px 0 #cacaca;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	.chat-fans-i-extra .chat-fans-ie-item{
		width: 50%;
		display: block;
		height: 36px;
		line-height: 36px;
		color: #888888;
		overflow: hidden;
	}
	.chat-fans-ie-item span{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-fans-ie-item .chat-fans-ie-title{
		margin-right: 5px;
	}
	.chat-fans-ie-item .chat-fans-ie-online{
		width: 12px;
		height: 12px;
		background-color: #009688;
		border-radius: 6px;
	}
	.chat-fans-i-wrap .chat-fans-i-tools{
		width: 100%;
		height: 40px;
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}
	.chat-fans-i-tools .chat-fans-it-item{
		height: 40px;
		line-height: 40px;
		margin: 0 10px;
		padding: 0 10px;
		background-color: #009688;
		color: #FFFFFF;
		border-radius: 4px;
		cursor: pointer;
	}
	.chat-fans-i-tools .chat-fans-refresh{
		background-color: #13b9ff !important;
	}
	.chat-fans-it-item span{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-fans-it-item .chat-fans-it-icon{
		width: 20px;
		height: 20px;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		margin-right: 5px;
	}
	.chat-fans-it-send{
		background-image: url(../../../assets/img/chat-white.png);
	}
	.chat-fans-it-refresh{
		background-image: url(../../../assets/img/refresh-white.png);
		background-size: 18px auto !important; 
	}
</style>
